module.exports = __webpack_public_path__ + "img/e9f6b7e4-ad48-4b19-a4f4-2eb9e2c32561.15ee3307.png";